import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './loading.service';
import { AuthService } from './auth.service';
import { environment as env } from '../../environments/environment';
import { ToastService } from './toast.service';
const localLog = console.log;

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private http: HttpClient,
    private loadingService: LoadingService,
    private authService: AuthService,
    private toast: ToastService) {
  }

  private _get_headers() {
    return {      withCredentials: true
    };
  }

  async upload_fingerprints_data(data: string[]): Promise<any> {
    let _id = this.loadingService.add('Upload Fingerprints Data ...');
    try {
      let res: any = await this.http.post(
        `${env.apiUrl}/rest/admin/utils/fingerprints-data`,
        { data: data },
        this._get_headers(),
      ).toPromise();

      if (res?.err) {
        throw new Error(res.err);
      }

      this.loadingService.remove(_id);
      return res;
    }
    catch (e: any) {
      localLog('Error upload_fingerprints_data() =>', e);
      this.toast.error('Failed to upload Fingerprints data', e.message);
      this.loadingService.remove(_id);
      return { err: e.message }
    }
  }
}
